<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row dflex">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="{{ messageService.get_search() }}" autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div class="service_pager">
            <span>
                <div class="video_div1 hidden-xs" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="new1" (click)='check_access(1,1,"",1,1)' [disabled]='new_status'>
                    <span>{{ messageService.get_new() }}</span>
                </button>
                <button class="search1" (click)='open_detaile(0,3,0,2)'>
                    <span>{{ messageService.get_filter() }}</span>
                </button>
                <div class="pager_pe">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,5,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation'><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-body control-content-body" (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" class='table-scroll mat_table_fa_without_scroll pe1'>

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px'
                (click)="reset_sort('wharehouse_invoice_id','desc')">
                <span>#</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{
                i + page_number_first }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:45px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="invoice_date">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'wharehouse_invoice_date3 ' + asc_desc }"
                (click)="sort('wharehouse_invoice_date3',asc_desc)" style="max-width: 130px;">
                <span>تاریخ سند</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_invoice_id,2)"
                style="max-width: 130px;">
                <span>{{ x.wharehouse_invoice_date3 }} </span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 130px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="user">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'user_title ' + asc_desc }"
                (click)="sort('user_title',asc_desc)" style="min-width: 250px;">
                <span>نام طرف حساب</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="min-width: 250px;">
                <div class="right fright" (click)="open_detaile(i,2,x.wharehouse_invoice_id,2)"> {{ x.user_title }}
                </div>
                <div class="left fleft">
                    <span class="fleft" [matMenuTriggerFor]="menu" (click)="get_customer(x.user_id)"><i
                            class="fas fa-info-circle icon"></i></span>
                    <span [matMenuTriggerFor]="menu3" (click)="get_menu(i,x)">
                        <i class="fas fa-comments"></i>
                    </span>
                    <span [matMenuTriggerFor]="menu2" (click)="get_menu(i,x)">
                        <i class="fas fa-print icon"></i>
                    </span>
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="min-width: 250px;"></mat-footer-cell>
        </ng-container>
        <mat-menu #menu="matMenu" class="reception-mat-menu-panel" xPosition="before">
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr>
                    <td class="cursor right">
                        <a href="/home/financial2/202?user={{ customer_id }}" target="_blank">صورتحساب اشخاص {{
                            customer_title
                            }}</a>
                    </td>
                </tr>
                <tr>
                    <td class="cursor right">
                        <a href="/home/finance-cardex/226?user={{ customer_id }}" target="_blank">کاردکس اشخاص {{
                            customer_title
                            }}</a>
                    </td>
                </tr>
            </table>
        </mat-menu>
        <mat-menu #menu2="matMenu" class="reception-mat-menu-panel" xPosition="before">
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr>
                    <td class="cursor right" (click)="show_factor1()">
                        <span class="eye">
                            <i class="fas fa-print icon"></i>
                        </span>
                        <span>
                            <span>چاپ فاکتور تعمیرگاه</span>
                        </span>
                    </td>
                </tr>
            </table>
        </mat-menu>
        <mat-menu #menu3="matMenu" class="reception-mat-menu-panel" xPosition="before">
            <table class="table table-bordered" (click)="$event.stopPropagation()">
                <tr>
                    <td class="cursor right" (click)="open_sms()">
                        <span class="eye"><i class="far fa-comments"></i></span>
                        <span> ارسال پیامک فاکتور آنلاین </span>
                    </td>
                </tr>
            </table>
        </mat-menu>

        <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'wharehouse_invoice_amount ' + asc_desc }"
                (click)="sort('wharehouse_invoice_amount',asc_desc)" style="max-width: 130px;">
                <span>مبلغ</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_invoice_id,2)"
                style="max-width: 130px;">{{
                x.wharehouse_invoice_amount | number }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 130px;">{{ sum | number }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="invoice_number">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'wharehouse_invoice_number ' + asc_desc }"
                (click)="sort('wharehouse_invoice_number',asc_desc)" style="max-width: 130px;">
                <span>شماره فاکتور</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_invoice_id,2)"
                style="max-width: 130px;">
                {{x.wharehouse_invoice_number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 130px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="settlement">
            <mat-header-cell *matHeaderCellDef
                [ngClass]="{active1:order == 'wharehouse_invoice_settlement_date ' + asc_desc }"
                (click)="sort('wharehouse_invoice_settlement_date',asc_desc)" style="max-width: 130px;">
                <span>تاریخ تسویه</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_invoice_id,2)"
                style="max-width: 130px;">
                {{
                x.wharehouse_invoice_settlement_date || '-' }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 130px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="comment">
            <mat-header-cell *matHeaderCellDef [ngClass]="{active1:order == 'wharehouse_invoice_comment ' + asc_desc }"
                (click)="sort('wharehouse_invoice_comment',asc_desc)">
                <span>توضیحات</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.wharehouse_invoice_id,2)">
                <div class="right">{{x.wharehouse_invoice_comment || '-' }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="pay">
            <mat-header-cell *matHeaderCellDef style="max-width:130px" [hidden]="access_insert_finance == false">
                <span>میانبر پرداخت</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style="max-width:130px;padding:0.2rem !important"
                [hidden]="access_insert_finance == false">
                <span (click)="pay(x.user_id,x.wharehouse_invoice_amount,x.wharehouse_invoice_number)">
                    <mat-icon>credit_card</mat-icon>
                </span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:130px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:70px'>
                <span>عملیات</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:70px'>
                <span (click)="check_access(3,0,x.wharehouse_invoice_id,0,1)"><i class="far fa-trash-alt icon"
                        style='margin:0px 4px;'></i></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:70px'></mat-footer-cell>
        </ng-container>

        <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
        </mat-header-row>
        <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
            (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow || i == back_i,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>
        <mat-footer-row style="background: rgb(245 245 163) !important;bottom:-2px"
            *matFooterRowDef="displayedColumns;sticky : true"></mat-footer-row>
    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview2.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>